import store from "../../state/store"
import { isTrueValue } from "../helper-functions/is-true-value";
import { isCryptoCurrency } from "../helper-functions/is_crypto_currency";

const fourChar = ['CLF','UYW'];
const threeChar = ['BHD','IQD','JOD','KWD','LYD','OMR','TND'];
const noChar = [
    'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW',
    'PYG', 'RWF', 'UGX', 'UYI', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'
];

export const defineDecimalPlaces = (currency) => {
    const {
        initTheme: { theme_editor_settings: { customization_settings: { layout } = {} } = {} } = {},
        profileInfo: { available_currencies: { currencies } = {} } = {},
        gatewayInfo: { cryptoList=[] },
        resultOfPay: { transaction } = {}
    } = store.getState();
    const charge_currency = transaction?.charge_currency;
    const is_crypto = transaction?.is_crypto;
    const isCrypto = (currency === charge_currency && (is_crypto || cryptoList.includes(currency))) || isCryptoCurrency(currency);
    const isAmountFirstLayout = layout === 'amount-first';
    const isCryptoAvailableCurrency = !!currencies?.find((curr) => curr.code === currency && isTrueValue(curr.crypto));

    let decimalPlaces = 2;
    if(cryptoList.includes(currency) || isCrypto || (isAmountFirstLayout && isCryptoAvailableCurrency)) decimalPlaces = 8;
    if(fourChar.includes(currency)) decimalPlaces = 4;
    if(threeChar.includes(currency)) decimalPlaces = 3;
    if(noChar.includes(currency)) decimalPlaces = 0;

    return decimalPlaces
}

